





























import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import GeneralLedgerSettingsEdit from '@/components/Products/Forms/Shared/GeneralLedgerSettingsEdit.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';

@Component({ name: 'MappingDefaultsEditDialog', components: { GeneralLedgerSettingsEdit } })
export default class extends SaascadaVueDialog {

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            ProductDetailsModule.prepareProductViewModel();
        }
    }

    async save() {
        if (!(this.$refs.form as any).validateForm()) {
            return;
        }
        else {
            this.dialog = false;
            await ProductDetailsModule.editGeneralLedgerMappings();
            await ProductDetailsModule.getHistory();
        }
    }

}
